import Vue from 'vue'
import Vuex from 'vuex'
import alert from '@/components/Alert/module'
import post from '@/components/Post/module'
import gallery from '@/components/Gallery/module'
import category from '@/components/Category/module'
import album from '@/components/Album/module'
import size from '@/components/Size/module'
import home from '@/components/Home/module'

Vue.use(Vuex)
export default function createStore() {
  return new Vuex.Store({
    modules: {
      alert,
      home,
      post,
      gallery,
      category,
      album,
      size
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js